import { postExternalApiEvent } from '../../external-api-events/postExternalApiEvent';
import { QUICK_LINK_BUTTON_CLICK } from '../../external-api-events/constants/externalApiEventTypes';
import { QUICK_LINKS } from 'conversations-message-history/common-message-format/constants/attachmentTypes';
export const postQuickLinkButtonClickEvent = ({
  label
}) => () => {
  postExternalApiEvent({
    eventType: QUICK_LINK_BUTTON_CLICK,
    payload: {
      name: QUICK_LINKS,
      value: label
    }
  });
};